module.exports = __webpack_public_path__ + "img/kelebihan-6.1069a26b.jpg";